import { render, staticRenderFns } from "./ConfirmQuarantineAdmissions.vue?vue&type=template&id=68d31916"
import script from "./ConfirmQuarantineAdmissions.vue?vue&type=script&lang=js"
export * from "./ConfirmQuarantineAdmissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports